module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-down_black-516fbf145bf6fc5e89ef4c1eee430953.svg";